// import React, { useEffect } from 'react';
// import { Container, Typography, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
// import { useNavigate } from 'react-router-dom';
// import { useFetchOrganizationsQuery } from '../../services/profileService';
// import AddIcon from "@mui/icons-material/Add";

// const ViewOrganizations = () => {
//   const navigate = useNavigate();
//   const { data: organizations, isLoading, refetch } = useFetchOrganizationsQuery();

//   useEffect(() => {
//     refetch();
//   }, [refetch]);

//   const handleAddOrganization = () => {
//     navigate('/superadmin-dashboard'); // Redirect to Add Organization page
//   };

//   // const handleBack = () => {
//   //   navigate("/view-org");
//   // };

//   if (isLoading) return <Typography>Loading organizations...</Typography>;

//   return (
//     <Container>
//       <Typography variant="h4" sx={{ mb: 2 ,mt:3}}>List of Organizations</Typography>

//       {/* <Button
//         variant="contained"
//         color="primary"
//         onClick={handleAddOrganization}
//         sx={{ mb: 4 }}
//       >
//         Add Organization
//       </Button> */}
//       <Button
//           variant="contained"
//           color="primary"
//           startIcon={<AddIcon />}  // Add the icon before the text
//           sx={{
//             marginLeft: 2,
//             top: '5px',
//             marginBottom:4,
//             right: '10px',
//             fontSize: '16px',  // Text size adjustment
//             padding: '8px 16px',  // Padding adjustment for the button
//             '&:hover': {
//               backgroundColor: '#e3f2fd',  // Light blue background on hover
//             },
//           }}
//           onClick={handleAddOrganization}
//         >
//           Add Organization  {/* Display the text next to the icon */}
//         </Button>

//       <TableContainer component={Paper}>
//         <Table>
//           <TableHead>
//             <TableRow>
//               <TableCell>Organization Name</TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {organizations?.data?.map((organization) => (
//               <TableRow key={organization.id}>
//                 <TableCell>{organization.name}</TableCell>
//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>
//       </TableContainer>
//     </Container>
//   );
// };

// export default ViewOrganizations;

import React, { useEffect, useMemo, useState } from "react";
import {

  Typography,
  Button,
  TextField,

  styled,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useFetchOrganizationsQuery } from "../../services/profileService";
import AddIcon from "@mui/icons-material/Add";
import { DataGrid } from "@mui/x-data-grid";

const getOrgLastModifiedValue = (organization) => {
  if (!organization) return null;
  return (
    organization.updated_at ??
    organization.updatedAt ??
    organization.modified_at ??
    organization.modifiedAt ??
    organization.last_modified ??
    organization.lastModified ??
    organization.lastModifiedAt ??
    organization.last_modified_at ??
    organization.last_updated ??
    organization.lastUpdated ??
    organization.updated ??
    organization.modified
  );
};

const toTimestamp = (value) => {
  if (!value) return null;
  if (typeof value === "number" && Number.isFinite(value)) return value;
  const t = new Date(value).getTime();
  return Number.isNaN(t) ? null : t;
};

const formatLastModified = (ts) => {
  if (!ts) return "—";
  try {
    return new Date(ts).toLocaleString();
  } catch {
    return "—";
  }
};

const ViewOrganizations = () => {
  const navigate = useNavigate();
  const {
    data: organizations,
    isLoading,
    refetch,
  } = useFetchOrganizationsQuery();

  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    refetch();
  }, [refetch]);

  const handleAddOrganization = () => {
    navigate("/superadmin-dashboard"); // Redirect to Add Organization page
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleViewDetails = (id) => {
    navigate(`/organizations/${id}`);
  };

  const handleEditOrganization = (id) => {
    navigate(`/organizations/${id}/edit`);
  };

  const handleResetPassword = (id) => {
    navigate(`/organizations/${id}/reset-password`);
  };

  const handleShowMembers = (id, name) => {
    navigate(`/organizations/${id}/members`, {
      state: { organizationName: name },
    });
  };

  const columns = [
    {
      field: "id",
      headerName: "ID",
      minWidth: 100,
    },
    {
      field: "name",
      headerName: "Organization Name",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "lastModified",
      headerName: "Last Modified",
      minWidth: 220,
      flex: 1,
      valueGetter: (_value, row) => row.lastModifiedTs,
      renderCell: (params) => params.row.lastModifiedDisplay,
      sortComparator: (v1, v2) => {
        const a = typeof v1 === "number" ? v1 : null;
        const b = typeof v2 === "number" ? v2 : null;
        if (a === null && b === null) return 0;
        if (a === null) return 1; // nulls last
        if (b === null) return -1;
        return a - b;
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 520,
      sortable:false,
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "5px",
            height: "100%",
          }}
        >
          <CustomBtn
            sx={{ background: "#2E7D32", borderColor: "#2E7D32", margin: 0 }}
            onClick={() => handleShowMembers(params.row.id, params.row.name)}
          >
            Show
          </CustomBtn>
          <CustomBtn
            sx={{ background: "#1085AB", borderColor: "#1085AB", margin: 0 }}
            onClick={() => handleViewDetails(params.row.id)}
          >
            View Details
          </CustomBtn>
          <CustomBtn sx={{ margin: 0 }} onClick={() => handleEditOrganization(params.row.id)}>
            Edit
          </CustomBtn>
          <CustomBtn
            sx={{ background: "#d32f2f", borderColor: "#d32f2f", margin: 0 }}
            onClick={() => handleResetPassword(params.row.id)}
          >
            Reset Password
          </CustomBtn>
        </Box>
      ),
    },
  ];

  const rows = useMemo(() => {
    const list = Array.isArray(organizations?.data) ? organizations.data : [];
    return list.map((organization) => ({
      id: organization.id,
      name: organization.name,
      lastModifiedTs: toTimestamp(getOrgLastModifiedValue(organization)),
      lastModifiedDisplay: formatLastModified(
        toTimestamp(getOrgLastModifiedValue(organization))
      ),
    }));
  }, [organizations?.data]);

  const filteredRows = useMemo(() => {
    const q = String(searchQuery || "").trim().toLowerCase();
    if (!q) return rows;
    return rows.filter((row) => {
      const idText = String(row?.id ?? "").toLowerCase();
      const nameText = String(row?.name ?? "").toLowerCase();
      const modifiedText = String(row?.lastModifiedDisplay ?? "").toLowerCase();
      return (
        idText.includes(q) || nameText.includes(q) || modifiedText.includes(q)
      );
    });
  }, [rows, searchQuery]);

  if (isLoading) return <Typography>Loading organizations...</Typography>;

  return (
    <>
      <SectionWrap component="section">
        <ContainerWrap>
          <RowWrap sx={{ marginBottom: "10px" }}>
            <Col12Wrap>
              <TitleWrap
                sx={{ textTransform: "capitalize", marginBottom: "0" }}
              >
                List of Organizations
              </TitleWrap>
            </Col12Wrap>
          </RowWrap>
          <RowWrap sx={{ marginBottom: "20px", alignItems: "center" }}>
            <Col6Wrap>
              <CustomBtn
                sx={{
                  padding: "7px 10px",
                  margin: "0",
                  "& .MuiButton-icon": { marginRight: "3px", marginLeft: "0" },
                }}
                startIcon={<AddIcon />}
                onClick={handleAddOrganization}
              >
                Add Organization
              </CustomBtn>
            </Col6Wrap>
            <Col6Wrap>
              <FormGroupWrap>
                <CustomTextField
                  variant="outlined"
                  placeholder="Search by ID, name, or last modified"
                  value={searchQuery}
                  onChange={handleSearchChange}
                />
              </FormGroupWrap>
            </Col6Wrap>
          </RowWrap>
          <RowWrap>
            <Col12Wrap>
              <TableContentwrap>
                <DataGrid
                  rows={filteredRows}
                  columns={columns}
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 30,
                      },
                    },
                  }}
                  pageSizeOptions={[30]}
                  disableRowSelectionOnClick
                  disableColumnMenu={true}
                  localeText={{ noRowsLabel: "No rows available" }}
                  sx={{
                    "& .MuiDataGrid-iconButtonContainer": {
                      visibility: 'visible !important',
                      width: 'auto !important',
                      "svg": {
                        opacity:'1 !important',
                      }
                    } 
                  }}
                />
              </TableContentwrap>
            </Col12Wrap>
          </RowWrap>
        </ContainerWrap>
      </SectionWrap>
    </>
  );
};

export default ViewOrganizations;

const SectionWrap = styled(Box)(() => ({
  padding: "30px 0",
}));
const ContainerWrap = styled(Box)(() => ({
  width: "100%",
  maxWidth: "100%",
  paddingLeft: "15px",
  paddingRight: "15px",
  marginLeft: "auto",
  marginRight: "auto",
}));
const RowWrap = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
  marginLeft: "-15px",
  marginRight: "-15px",
}));
const Col12Wrap = styled(Box)(() => ({
  flex: "0 0 auto",
  width: "100%",
  maxWidth: "100%",
  paddingLeft: "15px",
  paddingRight: "15px",
}));
const Col6Wrap = styled(Box)(() => ({
  flex: "0 0 auto",
  width: "100%",
  maxWidth: "50%",
  paddingLeft: "15px",
  paddingRight: "15px",
  "@media (max-width: 991px)": {
    maxWidth: "100%",
    marginTop: "10px",
    marginBottom: "10px",
  },
}));
const TitleWrap = styled(Typography)(() => ({
  fontSize: "28px",
  fontWeight: "600",
  lineHeight: "1.445",
  color: "#000000",
  marginBottom: "15px",
}));
const CustomBtn = styled(Button)(() => ({
  minWidth: "auto",
  fontSize: "14px",
  fontWeight: "400",
  lineHeight: "1",
  color: "#ffffff",
  textTransform: "capitalize",
  background: "#F28021",
  borderColor: "#F28021",
  borderRadius: "5px",
  padding: "10px",
  margin: "0 5px",
  boxShadow: "none !important",
}));
const TableContentwrap = styled(Box)(() => ({
  padding: "15px",
  background: "#ffffff",
  borderRadius: "7px",
  boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.05)",
}));

const FormGroupWrap = styled(Box)(() => ({
  maxWidth: "420px",
  marginLeft: "auto",
  marginBottom: "0px",
  position: "relative",
  "@media (max-width: 991px)": {
    maxWidth: "100%",
  },
}));

const CustomTextField = styled(TextField)(() => ({
  width: "99%",
  border: "1px solid #DADADA",
  background: "#ffffff",
  borderRadius: "7px",
  "& .MuiInputBase-input": {
    fontSize: "16px",
    fontWeight: "300",
    lineHeight: "1",
    color: "#333333",
    padding: "10px 20px",
  },
  "& fieldset": {
    border: "none",
  },
}));
